import { render, staticRenderFns } from "./DetailUpdateV2.vue?vue&type=template&id=1b5d2e5a"
import script from "./DetailUpdateV2.vue?vue&type=script&lang=js"
export * from "./DetailUpdateV2.vue?vue&type=script&lang=js"
import style0 from "./DetailUpdateV2.vue?vue&type=style&index=0&id=1b5d2e5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports